import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Button, Flex } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';

import FormInput from '../../../../../../components/form/FormInput';
import { inputTypes } from '../../../../../../components/form/FormInput/util';
import { analyticsIds } from '../../../../../../constants/analyticsIds';
import { selectUser, updateUserPassword } from '../../../../../../redux/modules/user';
import { schema } from '../../../../../../utils/passwordSchema';

const ChangePasswordForm = () => {
  const { userId } = useSelector(selectUser);
  const dispatch = useDispatch();
  const useFormMethods = useForm({ resolver: yupResolver(schema) });

  const { handleSubmit, formState: { isSubmitSuccessful, isSubmitting }, reset } = useFormMethods;

  const onSubmit = async data => {
    const { existingPassword, password, confirmPassword } = data;

    dispatch(updateUserPassword(userId, existingPassword, password, confirmPassword));
  };

  useEffect(() => {
    if (isSubmitSuccessful) {
      reset({ existingPassword: '', password: '', confirmPassword: '' });
    }
  }, [isSubmitSuccessful, reset]);

  return (
    <Box pt={4} px={6} textAlign="left">
      <form id="updatePassword" onSubmit={handleSubmit(onSubmit)}>
        <Flex direction="column" width="45%">
          <FormInput
            dataAnalyticsId="existingPassword"
            inputName="existingPassword"
            labelName="Current Password"
            placeholder="Enter Current Password"
            size="lg"
            type={inputTypes.password}
            useFormMethods={useFormMethods}
          />
          <FormInput
            dataAnalyticsId="password"
            inputName="password"
            labelName="New Password"
            placeholder="Enter New Password"
            size="lg"
            type={inputTypes.password}
            useFormMethods={useFormMethods}
          />
          <FormInput
            dataAnalyticsId="confirmPassword"
            inputName="confirmPassword"
            labelName="Confirm New Password"
            placeholder="Confirm New Password"
            size="lg"
            type={inputTypes.password}
            useFormMethods={useFormMethods}
          />
        </Flex>
        <Button
          data-analytics-id={analyticsIds.userSettings.profile.changePasswordButton}
          dusk={analyticsIds.userSettings.profile.changePasswordButton}
          isDisabled={isSubmitting}
          mt={4}
          type="submit"
          variant="secondary"
          width="45%"
        >
          Change Password
        </Button>
      </form>
    </Box>
  );
};

export default ChangePasswordForm;
